// latest: zhangmyh 2017-2-24 9:12 AM
// 评估组参照
/* global $ u */
import Collection from 'common/vo/collection'
import 'collection/evaluationGroup/evalGroupRefer'
// import { Get } from 'common'

function init (refer) {
  // 树形控件加载有误,所以需要每次都重新加载
  let trees = Collection.create('evalgroup.referlist')
  trees.load({ id: 0 })
  let selectItem = {}
  let vm = {
    treemodel: trees.datatable,
    treeOption: {
      callback: {
        beforeClick: async function (id, obj) {
          /* if (!obj.flag) {
            var res = await Get('/cpu-supplymgr/supplyMgrEvaluate/evaluateGroup/selectByParentId', {
              id: obj.id
            })
            if (res.data && res.data.result && res.data.result.length) {
              trees.datatable.addSimpleData(res.data.result)
            }
            obj.flag = true
          } */
          selectItem = obj
        }
      }
    }
  }
  let app = u.createApp()
  app.init(vm, $('#evalgroup_refer')[0])

  refer.registerSubmitFunc(function () {
    return selectItem
  })
}
let template = require('./index.html')
export default {
  init,
  template
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/evaluationGroup/index.js